export default defineAppConfig({
    title: '数据网',
    theme: {
      dark: true,
      colors: {
        primary: '#ff0000'
      }
    }
  })
  